
import {
  ref,
  defineComponent,
  reactive,
  getCurrentInstance,
  onMounted,
} from "vue";
import router from "@/router";
import { useRouter, useRoute } from "vue-router";
import { getArticleById } from "../views/api/user";

export default defineComponent({
  setup() {
    let router1 = useRoute();
    // let routerUrl = useRouter();

    let pageNoData = reactive<any[]>([]);
    let show = reactive<any>(router1.params.type);
    show = JSON.parse(show);
    // chrome
    document.body.scrollTop = 0;
    // firefox
    document.documentElement.scrollTop = 0;
    router.beforeEach((to, from, next) => {
      // chrome
      document.body.scrollTop = 0;
      // firefox
      document.documentElement.scrollTop = 0;

      next();
    });
    //获取全局变量
    const proxy = getCurrentInstance() as any;
    let show1 = ref<any>(true);
    //全局语言
    if (window.sessionStorage.getItem("language") as string) {
      var lan = JSON.parse(proxy.appContext.config.globalProperties.$language);
    }
    if (lan == "EN") {
      show1.value = false;
    } else {
      show1.value = true;
    }

    let indexPage = ref<number>(0);
    let newsTitle = ref({
      name: router1.params.name,
      title1: router1.params.title,
    });
    let url = ref("");

    console.log("newsTitle", newsTitle);
    let newsData = ref({});
    //获取文章数据
    const getData = async (id) => {
      const ID = reactive({
        id: id ? id : (router1.params.id as any),
      });
      const res = await getArticleById.getData(ID);
      newsData.value = res.data.result;
      console.log("newsData", newsData);
    };

    //跳转链接
    const goLink = () => {
      if (newsTitle.value.name == "科技前沿" || newsTitle.value.name == "Latest Research") {
        router.push({ path: "/technologicalFrontier" });
      } else if (
        newsTitle.value.name == "新闻" ||
        newsTitle.value.name == "News"
      ) {
        router.push({ path: "/news" });
      }else if (
        newsTitle.value.name == "研究与创新" ||
        newsTitle.value.name == "Research and Innovation"
      ) {
        router.push({ path: "/researchInnovation" });
      }
    };

    //页脚跳转
    const goArticle = (num) => {
      if (num == 1) {
        if (indexPage.value == 0) {
          alert("第一页");
        } else {
          getData(pageNoData[indexPage.value - 1].id);
          router1.params.id = pageNoData[indexPage.value - 1].id;
        }
      } else if (num == 2) {
        if (indexPage.value == pageNoData.length - 1) {
          alert("最后一页");
        } else {
          getData(pageNoData[indexPage.value + 1].id);
          router1.params.id = pageNoData[indexPage.value + 1].id;
        }
      } else {
        router.push({ path: "/technologicalFrontier" });
      }

      pageNo();
      // chrome
      document.body.scrollTop = 0;
      // firefox
      document.documentElement.scrollTop = 0;
    };

    //判断页脚左右俩边的title
    const pageNo = () => {
      let a = window.sessionStorage.getItem("absorbData") as string;
      pageNoData = JSON.parse(a);

      console.log("pageNoData", pageNoData);

      pageNoData.forEach((item, index) => {
        if (item.id == (router1.params.id as any)) {
          indexPage.value = index;
        }
      });
    };
    pageNo();

    onMounted(() => {
      getData(null);
    });

    return {
      router,
      getData,
      goLink,
      pageNo,
      goArticle,
      url,
      newsData,
      show,
      show1,
      newsTitle,
      pageNoData,
      indexPage,
    };
  },
});
